import {
  createStyles,
  createTheme,
  makeStyles,
  Theme,
  withStyles
} from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    fieldNoBottomMargin: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 0
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    sizeUnit: {
      width: theme.spacing(7)
    },
    filterButtons: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      display: "flex",
      justifyContent: "right"
    },
    applyFilter: {
      marginLeft: theme.spacing(2)
    },
    dateRangeContainer: {
      display: "flex",
      alignItems: "center"
    },
    dateRangeTooltip: {
      padding: "0.5rem",
      fontSize: "1rem"
    },
    dateRangeHelp: {
      color: "rgba(0, 0, 0, 0.54)",
      margin: "0 0 0.5rem 1rem",
      cursor: "pointer"
    },
    dateDialog: {
      position: "inherit"
    },
    dateRangeAbsolute: {
      border: "0 !important" as any,
      zIndex: 1000,
      position: "absolute",
      marginBottom: 10,
      fontSize: "1rem",
      "&::before": {
        left: 0,
        right: 0,
        bottom: 0,
        content: '"\\00a0"',
        position: "absolute",
        transition:
          "border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
        pointerEvents: "none"
      },
      "&::after": {
        left: 0,
        right: 0,
        bottom: 0,
        content: '""',
        position: "absolute",
        transform: "scaleX(0)",
        transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        borderBottom: "2px solid #3f51b5",
        pointerEvents: "none"
      }
    },
    iconButtonMobile: {
      padding: "12px 10px 0 0"
    },
    tabPanel: {
      padding: "0 !important",
      margin: "0",
      "& .MuiIconButton-root": {
        padding: "3px"
      },
      "& .MuiToolbar-root": {
        "& :nth-child(3) > div": {
          "& > div": {
            display: "flex",
            width: 130
          }
        }
      }
    },
    tabHeader: {
      backgroundColor: "#05598d"
    },
    tabEntry: {
      color: "#fff",
      textTransform: "none"
    },
    indicator: {
      backgroundColor: "#e3e9ff"
    },
    scanner: {
      "& > div": {
        flex: 1
      }
    },
    detailsDialog: {
      minHeight: "80%"
    },
    eventDetailTableContainer: {
      [theme.breakpoints.down("md")]: {
        justifyContent: "center"
      },
      [theme.breakpoints.up("lg")]: {
        justifyContent: "end"
      }
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    createDialogCheckbox: {
      marginTop: theme.spacing(4)
    },
    divider: {
      marginBottom: theme.spacing(1)
    },
    buttonInventory: {
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2),
        position: "fixed",
        bottom: 0,
        left: 0
      },
      [theme.breakpoints.up("md")]: {
        position: "absolute",
        bottom: 10,
        float: "left"
      }
    },
    eventDetailTable: {
      "& th": {
        color: theme.palette.grey[800]
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        "& th": {
          width: "auto"
        }
      },
      [theme.breakpoints.up("lg")]: {
        width: "90%",
        "& th": {
          width: "25%"
        }
      }
    },
    inventoryProcessedButton: {
      animation: "$wiggle .1s 25 alternate"
    },
    "@keyframes wiggle": {
      "0%": { transform: "rotate(-5deg)" },
      "100%": { transform: "rotate(5deg)" }
    },
    // dialogHeader: {
    //   display: "flex",
    //   alignItems: "center",
    //   flexWrap: "wrap",
    //   padding: theme.spacing(2)
    // },
    // datePickerWrapper: {
    //   flex: "1 1 auto",
    //   minWidth: "200px",
    //   maxWidth: "100%",
    //   marginTop: theme.spacing(1),
    //   [theme.breakpoints.up("sm")]: {
    //     marginTop: 0
    //   }
    // },
    container: {
      padding: theme.spacing(2)
    },
    headerCard: {
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(1),
      backgroundColor: "#f9f9f9"
    },
    eventsCard: {
      borderRadius: theme.spacing(1),
      overflow: "hidden",
      border: `1px solid ${theme.palette.divider}`
    },
    dialogHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(2),
      flexWrap: "wrap",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        "& > div": {
          marginBottom: theme.spacing(2)
        }
      }
    },
    datePickerWrapper: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        marginTop: theme.spacing(1)
      }
    },
    controls: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        flexWrap: "wrap",
        marginTop: theme.spacing(2),
        "& > *": {
          marginBottom: theme.spacing(1),
          marginLeft: "0 !important",
          marginRight: theme.spacing(2)
        }
      }
    },
    // closeButton: {
    //   position: "absolute",
    //   right: theme.spacing(1),
    //   top: theme.spacing(1),
    //   color: theme.palette.grey[500]
    // },
    // eventDetailTableContainer: {
    //   backgroundColor: "#f9fbfd",
    //   borderRadius: theme.spacing(1)
    // },
    detailPanel: {
      padding: theme.spacing(2),
      backgroundColor: "#f9fbfd"
    },
    cartActionsContainer: {
      maxHeight: "400px",
      overflowY: "auto",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1)
    },
    activeFiltersBar: {
      padding: theme.spacing(1.5, 2),
      marginBottom: theme.spacing(2),
      backgroundColor: "#f0f4f8",
      borderRadius: theme.spacing(1)
    },
    filterChip: {
      margin: theme.spacing(0.5),
      backgroundColor: theme.palette.background.default
    },
    timeGrouping: {
      fontWeight: 500,
      padding: theme.spacing(1.5, 2),
      backgroundColor: "#f5f7fa",
      borderRadius: theme.spacing(0.5),
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(1)
    },
    emptyState: {
      padding: theme.spacing(4),
      textAlign: "center",
      color: theme.palette.text.secondary
    }
  })
);

// ==============================
//     Theming
// ==============================

export const withPrimaryIcon = withStyles(({ palette }) => ({
  root: {
    backgroundColor: palette.primary.main,
    color: palette.background.default,
    borderRadius: "100%",
    padding: 2,
    height: 40,
    width: 40
  }
}));

export const withGrayBg = withStyles(({ palette }) => ({
  root: {
    backgroundColor: palette.grey[100],
    color: palette.background.default
  }
}));

export const withCheckedGreen = withStyles(({ palette }) => ({
  root: {
    "&$checked": {
      backgroundColor: palette.success.main
    }
  },
  checked: {}
}));

export const withCheckedYellow = withStyles(({ palette }) => ({
  root: {
    "&$checked": {
      backgroundColor: palette.warning.main
    }
  },
  checked: {}
}));

export const withCheckedRed = withStyles(({ palette }) => ({
  root: {
    "&$checked": {
      backgroundColor: palette.error.main
    }
  },
  checked: {}
}));

export const theme = createTheme({
  palette: {},
  overrides: {
    MuiSvgIcon: {
      fontSizeSmall: { fontSize: "2rem" }
    },
    MuiGrid: {
      container: {
        alignContent: "baseline"
      }
    },
    MuiCardHeader: {
      root: {
        paddingBottom: 0
      }
    },
    MuiFormControl: {
      root: {
        display: "flex",
        justifyContent: "center",
        spacing: 2
      }
    },
    MuiFormControlLabel: {
      root: {
        borderRadius: 5
      }
    },
    MuiCardActions: {
      root: {
        justifyContent: "space-between"
      }
    },
    MuiIconButton: {
      root: {
        float: "right"
      }
    }
  },
  props: {
    MuiGrid: {
      xs: 12,
      spacing: 1
    },
    MuiRadio: {
      color: "default"
    }
  }
});
